import NoAvailableBoxesModal from '@/vcs/_shared/modals/NoAvailableBoxesModal.vue'
import CloseLockerPromptModal from '@/vcs/_shared/modals/CloseLockerPromptModal.vue'

export default {
  data: function () {
    return {
      NoAvailableBoxesModal,
      CloseLockerPromptModal
    }
  },
  methods: {
    openNoAvailableBoxesModal() {
      this.$store.commit('modal/open', {
        cmp: NoAvailableBoxesModal,
        size: 'full',
        callback: this.$killSession
      })
    },
    openCloseLockerPromptModal(
      message,
      callback,
      buttonConfirm = null,
      buttonCancel = null
    ) {
      this.$store.commit('modal/open', {
        cmp: CloseLockerPromptModal,
        size: 'popup',
        data: {
          message: message,
          buttonConfirm: buttonConfirm,
          buttonCancel: buttonCancel
        },
        callback: callback
      })
    }
  }
}
